import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DropdownService} from "../../../services/dropdown.service";
import {AuthService} from "../../../services/auth.service";
import {
  AgencyORIList,
  BallisticRecord, BallisticsDeleteReq, CountyCityList,
  icJWT_Account,
  IncidentRecord, IncidentSaveEditReq, LabInfo,
  NJPOPSearchParams, PersonDeleteReq,
  PersonRecord, StateList, WeaponDeleteReq,
  WeaponRecord
} from "../../../NIBINInterface";
import {FormControl} from "@angular/forms";
import {FormBuilder} from '@angular/forms';
import {IncidentService} from "../../../services/incident.service";
import {DownloadService} from "../../../services/download.service";
import {MatOptionSelectionChange} from "@angular/material/core";
import {DialogService} from "../../../services/dialog.service";
import Swal from "sweetalert2";
import {formatDate} from "@angular/common";
import {Observable, of} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-new-incident-form',
  templateUrl: './new-incident-form.component.html',
  styleUrls: ['./new-incident-form.component.css'],
  providers: [DropdownService, IncidentService, DownloadService]
})
export class NewIncidentFormComponent implements OnInit {
  @ViewChild("dialog") dialogTarget!: ElementRef;
  user: icJWT_Account = <icJWT_Account>{};
  @Input('Incident') data: IncidentRecord = <IncidentRecord>{
    IncidentID:null,
    Inc_State:"NJ",
    Status:'POTENTIAL',
    County:'',
    Inc_City:'',
    Dept:'',
    Persons: <PersonRecord[]>[],
    Weapon:<WeaponRecord[]>[],
    Ballistics:<BallisticRecord[]>[]
  };
  @Output('IncidentCreated') IncidentCreated = new EventEmitter<IncidentRecord>()
  @Output('IncidentShareEdit') IncidentShareEdit = new EventEmitter<IncidentSaveEditReq>()

  ddls: any = {
    incTypes: [],
    states: [],
    Caliber:[],
    ItemType:[],
    RelatedArea:[],
    WeaponClassification:[],
    WeaponType:[]
  };
  counties: CountyCityList[] = []
  cities: CountyCityList[] = []
  agencies: AgencyORIList[] = []

  //For The Multiselects on Step 1
  tempIncidents:string[] = []
  tempCaseEvent:string[] = []
  tempNJPOPRejectReason:string[] = []

  showNJPOPDenyReason: boolean= false
  isNJPOP_Or_Reason_Selected: boolean= false
  njpopCounties: CountyCityList[] = []
  njpopCities: CountyCityList[] = []
  njpopAgencies: AgencyORIList[] = []
  njpopQuery: NJPOPSearchParams = <NJPOPSearchParams>{
    county:null,
    city: null,
    agency: null,
    casenumber : null,
    fromDate: null,
    toDate: null
  }
  njpopQueryResult: any[] = []

  pendingDeletedWeapons:WeaponDeleteReq[] = [];
  pendingDeletedBallistics:BallisticsDeleteReq[] = [];
  pendingDeletedPersons:PersonDeleteReq[] = [];
  HoursList: string[] = [];


  //AutoComplete Form Controls
  CNTRL_NJPOP_COUNTY:FormControl = new FormControl();
  CNTRL_NJPOP_CITY:FormControl = new FormControl();
  CNTRL_INC_STATE:FormControl = new FormControl();
  CNTRL_INC_COUNTY:FormControl = new FormControl();
  CNTRL_INC_CITY:FormControl = new FormControl();
  CNTRL_INC_AGENCY:FormControl = new FormControl();
  CNTRL_WPN_CALIBER:FormControl = new FormControl();
  CNTRL_WPN_CLASSIFICATION:FormControl = new FormControl();
  CNTRL_BAL_CALIBER:FormControl = new FormControl();
  CNTRL_BAL_CL_LG:FormControl = new FormControl();
  CNTRL_BAL_CL_TWIST:FormControl = new FormControl();
  CNTRL_BAL_CL_TYPE:FormControl = new FormControl();



  //AutoComplete Filters
  FLTR_NJPOP_COUNTY!: Observable<CountyCityList[]>;
  FLTR_NJPOP_CITY!: Observable<CountyCityList[]>;
  FLTR_INC_STATE!: Observable<StateList[]>;
  FLTR_INC_COUNTY!: Observable<CountyCityList[]>;
  FLTR_INC_CITY!: Observable<CountyCityList[]>;
  FLTR_INC_AGENCY!: Observable<AgencyORIList[]>;
  FLTR_WPN_CALIBER!: Observable<any[]>;
  FLTR_WPN_CLASSIFICATION!: Observable<any[]>;
  FLTR_BAL_CALIBER!: Observable<any[]>;
  FLTR_BAL_CL_LG!: Observable<any[]>;
  FLTR_BAL_CL_TWIST!: Observable<any[]>;
  FLTR_BAL_CL_TYPE!: Observable<any[]>;

  private _FLTR_NJPOP_COUNTY(value: string): CountyCityList[] {
    return (value == null || value?.trim() == '')? this.njpopCounties:this.njpopCounties?.filter(f=>f.County?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_NJPOP_CITY(value: string): CountyCityList[] {
    return (value == null || value?.trim() == '')? this.njpopCities:this.njpopCities?.filter(f=>f.City?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_STATE(value: string): StateList[] {
    return (value == null || value?.trim() == '')? this.ddls.states:this.ddls.states?.filter((f:StateList)=>f.name?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_COUNTY(value: string): CountyCityList[] {
    return (!value || value?.trim() == '')? this.counties:this.counties?.filter(f=>f.County?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_CITY(value: string): CountyCityList[] {
    return (!value || value?.trim() == '')? this.cities:this.cities?.filter(f=>f.City?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_INC_AGENCY(value: string): AgencyORIList[] {
    return (!value || value?.trim() == '')? this.agencies:this.agencies?.filter(f=>f.DeptName?.toLowerCase().includes(value?.toLowerCase()));
  }
  private _FLTR_WPN_CALIBER(value: string): any[] {
    return (value == null || value?.trim() == '')? this.ddls.Caliber:this.ddls.Caliber?.filter((f:any)=> {
      return f?.DDL_Desc?.toLowerCase().includes(value?.toLowerCase())
    });
  }
  private _FLTR_WPN_CLASSIFICATION(value: string): any[] {
    return (value == null || value?.trim() == '')? this.ddls.WeaponClassification:this.ddls.WeaponClassification?.filter((f:any)=> {
      return f?.DDL_Desc?.toLowerCase().includes(value?.toLowerCase())
    });
  }

  constructor(private authService: AuthService, private dropdownService: DropdownService, private incidentService: IncidentService, public downloadService: DownloadService, private _formBuilder: FormBuilder, private dialogService: DialogService) {
    this.user = this.authService.getUser()
    this.loadDDLS()
  }

  SET_FLTR_NJPOP_COUNTY(){
    this.FLTR_NJPOP_COUNTY = this.CNTRL_NJPOP_COUNTY.valueChanges.pipe(startWith(''), map(value => this._FLTR_NJPOP_COUNTY(value)));
  }
  SET_FLTR_NJPOP_CITY(){
    this.FLTR_NJPOP_CITY = this.CNTRL_NJPOP_CITY.valueChanges.pipe(startWith(''), map(value => this._FLTR_NJPOP_CITY(value)));
  }
  SET_FLTR_INC_STATE(){
    this.FLTR_INC_STATE = this.CNTRL_INC_STATE.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_STATE(value)));
  }
  SET_FLTR_INC_COUNTY(){
    this.FLTR_INC_COUNTY = this.CNTRL_INC_COUNTY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_COUNTY(value)));
  }
  SET_FLTR_INC_CITY(){
    this.FLTR_INC_CITY = this.CNTRL_INC_CITY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_CITY(value)));
  }
  SET_FLTR_INC_AGENCY(){
    this.FLTR_INC_AGENCY = this.CNTRL_INC_AGENCY.valueChanges.pipe(startWith(''), map(value => this._FLTR_INC_AGENCY(value)));
  }
  SET_FLTR_WPN_CALIBER(){
    this.FLTR_WPN_CALIBER = this.CNTRL_WPN_CALIBER.valueChanges.pipe(startWith(''), map(value => this._FLTR_WPN_CALIBER(value)));
  }
  SET_FLTR_WPN_CLASSIFICATION(){
    this.FLTR_WPN_CLASSIFICATION = this.CNTRL_WPN_CLASSIFICATION.valueChanges.pipe(startWith(''), map(value => this._FLTR_WPN_CLASSIFICATION(value)));
  }
  ngOnInit(): void {

    this.SET_FLTR_NJPOP_COUNTY()
    this.SET_FLTR_NJPOP_CITY()
    this.SET_FLTR_INC_STATE()
    this.SET_FLTR_INC_COUNTY()
    this.SET_FLTR_INC_CITY()
    this.SET_FLTR_INC_AGENCY()
    this.SET_FLTR_WPN_CALIBER()
    this.SET_FLTR_WPN_CLASSIFICATION()


    this.HoursList = this.dropdownService.getHoursArray();

    let labsn=this.user.CurrentDept
    if(labsn && !this.data.ID){
      this.dropdownService.getLabInfo(labsn).then((lab:LabInfo)=>{
        this.data.Inc_State = lab.LAB_STATE;
        this.updateAgencyList()
        this.updateCountyList()
        this.updateCityAgencyList()
      });

    } else {
      this.updateAgencyList()
      this.updateCountyList()
      this.updateCityAgencyList()
    }


    if(this.data.Inc_Type)
      this.tempIncidents = this.data.Inc_Type.split(',')
    if(this.data.Inc_RelatedArea)
      this.tempCaseEvent = this.data.Inc_RelatedArea.split(',')
    if(this.data.NJPOPRejectReason) {
      this.tempNJPOPRejectReason = this.data.NJPOPRejectReason.split(',')
    }

    if(this.data.NJPopNo!= null || this.data.NJPOPRejectReason!=null) {
      this.isNJPOP_Or_Reason_Selected = true
      this.showNJPOPDenyReason = true
    }
  }

  addMissingDDLFromInc(){
    let DBEntry =
    {
      ID:0,
      County:this.data.County,
      City:this.data.Inc_City,
      State:this.data.Inc_State,
    }

    if (!(this.counties.some(e => e.County === this.data.County))) {
      this.counties.push(DBEntry)
    }
    if (!(this.cities.some(e => e.County === this.data.Inc_City))) {
      this.cities.push(DBEntry)
    }
    if (!(this.agencies.some(e => e.DeptName === this.data.Dept))) {
      this.agencies.push({
        DeptORI:this.data.DeptORI,
        State: this.data.Inc_State,
        DeptName:this.data.Dept
      })
    }



  }

  async loadDDLS():Promise<void>{
    this.ddls.incTypes = await this.dropdownService.getDDL("IncidentType")
    this.ddls.Caliber = await this.dropdownService.getDDL("Caliber")
    this.ddls.ItemType = await this.dropdownService.getDDL("ItemType")
    this.ddls.RelatedArea = await this.dropdownService.getDDL("RelatedArea")
    this.ddls.WeaponClassification = await this.dropdownService.getDDL("WeaponClassification")
    this.ddls.WeaponType = await this.dropdownService.getDDL("WeaponType")
    this.ddls.states = await this.dropdownService.getStates()

    if (this.data.Inc_State != null) {
      this.counties = await this.dropdownService.getCountyForState(this.data.Inc_State)
      this.njpopCounties = await this.dropdownService.getNJPOPCounty('NJ')
    }else {
      this.counties = await this.dropdownService.getCountyForState('NJ')
      this.njpopCounties = await this.dropdownService.getNJPOPCounty('NJ')
    }
  }

  validateStep1(showError:boolean) : boolean{
    return !(!this.data.Inc_State || this.data.Inc_State =='') && (this.tempIncidents.length > 0);
  }

  validateStep3(showError:boolean) : boolean{
    let ErrList:string[] = [];
    if(!this.data.Inc_State || this.data.Inc_State ==''){
      ErrList.push("State is Required")
      return false;
    }
    if(!this.data.County || this.data.County =='') {
      ErrList.push("County is Required")
      return false;
    }
    if(!this.data.Inc_City || this.data.Inc_City =='') {
      ErrList.push("City is Required")
      return false;
    }
    if(!this.data.Dept || this.data.Dept =='') {
      ErrList.push("Agency is Required")
      return false;
    }
    if(!this.data.LabNumber || this.data.LabNumber =='') {
      ErrList.push("Lab # is Required")
      return false;
    }
    if(!this.data.CaseNumber || this.data.CaseNumber =='') {
      ErrList.push("Case # is Required")
      return false;
    }
    if(!this.data.OccurrenceDate || this.data.OccurrenceDate =='') {
      ErrList.push("Occurrence Date is Required")
      return false;
    }
    if(!this.data.Inc_Location || this.data.Inc_Location =='') {
      ErrList.push("Location is Required")
      return false;
    }
    return true;
  }

  datesAreOnSameDay = (first:Date, second:Date) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

  validateStepWeapons(showError:boolean): boolean{
    if(this.data.Weapon)
      for(const o of this.data.Weapon) {
        if (!o.CALIBER || o.CALIBER == '')
          return false
        if (!o.W_CLASS || o.W_CLASS == '')
          return false
        if (!o.MAKE || o.MAKE == '')
          return false
        if (!o.MODEL || o.MODEL == '')
          return false
        if (!o.DTOFSUBMISSION || o.DTOFSUBMISSION == '')
          return false
        if (!o.DTOFCOLLECTION || o.DTOFCOLLECTION == '')
          return false

        if(this.data.OccurrenceDate && o.DTOFCOLLECTION && o.DTOFSUBMISSION){
          if(!this.datesAreOnSameDay(new Date(this.data.OccurrenceDate),new Date(o.DTOFCOLLECTION))) {
            if(new Date(this.data.OccurrenceDate) > new Date(o.DTOFCOLLECTION))
              return false;
          }
          if(!this.datesAreOnSameDay(new Date(o.DTOFSUBMISSION),new Date(o.DTOFCOLLECTION))) {
            if(new Date(o.DTOFCOLLECTION) > new Date(o.DTOFSUBMISSION))
              return false;
          }
        }

      }
    return true;
  }

  validateStepBallistics(showError:boolean): boolean{
    if(this.data.Ballistics)
      for(const o of this.data.Ballistics) {
        if (!o.Item_Quantity || o.Item_Quantity < 0)
          return false
        if (!o.DTOFSUBMISSION || o.DTOFSUBMISSION == '')
          return false
        if (!o.DTOFCOLLECTION || o.DTOFCOLLECTION == '')
          return false

        if(this.data.OccurrenceDate && o.DTOFCOLLECTION && o.DTOFSUBMISSION){
          if(!this.datesAreOnSameDay(new Date(this.data.OccurrenceDate),new Date(o.DTOFCOLLECTION))) {
            if(new Date(this.data.OccurrenceDate) > new Date(o.DTOFCOLLECTION))
              return false;
          }
          if(!this.datesAreOnSameDay(new Date(o.DTOFSUBMISSION),new Date(o.DTOFCOLLECTION))) {
            if(new Date(o.DTOFCOLLECTION) > new Date(o.DTOFSUBMISSION))
              return false;
          }
        }
      }
    return true;
  }

  validateIncident():Boolean{
    let count:number = 0;
    if(this.data.Weapon)
      count+=this.data.Weapon.length;
    if(this.data.Ballistics)
      count+=this.data.Ballistics.length;
    if(count<1) {
      Swal.fire({
        icon: 'error',
        title: 'System Notification',
        text: "There must be at least 1 Weapon or Ballistic Evidence",
        timerProgressBar:true,
        timer:5000
      })

    }

    let wpnCnt  = 0;
    if(this.data.Weapon)
      wpnCnt+= this.data.Weapon.length;
      if((this.data.Inc_Type?.toUpperCase()?.includes("Weapon Possession Arrest".toUpperCase()) || this.data.Inc_Type?.toUpperCase()?.includes("Recovered Weapon".toUpperCase())) && wpnCnt<1) {
        count=0;
        Swal.fire({
          icon: 'error',
          title: 'System Notification',
          text: "There must be at least 1 Weapon for Weapon Possession/Recovered Weapon",
          timerProgressBar:true,
          timer:5000
        })

    }


    return (count>0)
  }

  savedIncidentEditLink(){
    this.data.Inc_Type = this.tempIncidents.join(',')
    this.data.Inc_RelatedArea = this.tempCaseEvent?.length > 0 ? this.tempCaseEvent.join(',') : null;
    this.data.NJPOPRejectReason = this.tempNJPOPRejectReason?.length > 0 ? this.tempNJPOPRejectReason.join(','): null;

    let req : IncidentSaveEditReq = {
      IncidentRecord: this.data,
      WeaponDeleteReqs: this.pendingDeletedWeapons,
      BallisticsDeleteReqs: this.pendingDeletedBallistics,
      PersonDeleteReqs: this.pendingDeletedPersons
    }

    this.IncidentShareEdit.emit(req)
  }

  saveIncident() {
    this.data.Inc_Type = this.tempIncidents.join(',')
    this.data.Inc_RelatedArea = this.tempCaseEvent.join(',')
    this.data.NJPOPRejectReason = this.tempNJPOPRejectReason.join(',')

    if(!this.validateIncident())
      return;

    if(!this.data.Lab || this.data.Lab == ''){
          this.user = this.authService.getUser()
          this.data.Lab=this.user.CurrentDept
      }


    //Send delete to Backend for Weapon, and Ballistics
    for(let w of this.pendingDeletedWeapons)
      this.incidentService.deleteWeaponFromDB(w)
    for(let b of this.pendingDeletedBallistics)
      this.incidentService.deleteBallisticsFromDB(b)
    for(let p of this.pendingDeletedPersons)
      this.incidentService.deletePersonFromDB(p)

    this.IncidentCreated.emit(this.data)
  }

  addWeaponRecord() {
    this.data.Weapon?.unshift({
      CALIBER: null,
      CT_Ghost_Gun: false,
      SearModifyFlag:false,
      EvidenceMarker: null,
      ID: null,
      IDENTIFYING_MARKS: null,
      IMPORTER_NAME: null,
      IncidentID: null,
      MAKE: null,
      MANUFACTURER: null,
      MANUFACTURER_NAME: null,
      MODEL: null,
      Notes: null,
      OBLITERATED_INDICATOR: null,
      ORIGIN: null,
      ORIGIN_COUNTRY_NAME: null,
      REC_TIME_TO_CRIME: null,
      RGID_Number: null,
      RGID_State: null,
      SERIAL_NUMBER: null,
      W_CLASS: null,
      W_TYPE: null,
      W_TYPE_DESC: null,
      DTOFCOLLECTION: this.data.OccurrenceDate,
      DTOFSUBMISSION: null,
      PreviousHit: null,
    })

  }

  deleteWeaponRecord(w:WeaponRecord) {
    if(w.ID)
      this.pendingDeletedWeapons.push({IncidentID: this.data.IncidentID, WeaponID: w.ID})

    this.data.Weapon?.splice(this.data.Weapon?.indexOf(w),1)
  }

  setWeaponCheck(checked: boolean, weapon: WeaponRecord) {
    weapon.CT_Ghost_Gun = (checked)
  }
  setSearModifyFlag(checked: boolean, weapon: WeaponRecord) {
    weapon.SearModifyFlag = (checked)
  }

  addBallisticsRecord(type:string) {
    this.data.Ballistics?.unshift({
      CL_LG: null,
      CL_Twist: null,
      CL_Type: null,
      Caliber_Type: null,
      EvidenceMarker: null,
      Headstamp: null,
      ID: null,
      IncidentID: null,
      Item_Quantity: null,
      Item_Type: null,
      Notes: null,
      VGID_CPart: type,
      VGID_Number: null,
      VGID_State: null,
      VGID_Status: null,
      DTOFCOLLECTION: this.data.OccurrenceDate,
      DTOFSUBMISSION: null,
      PreviousHit: null
    })
  }
  deleteBallisticsRecord(b:BallisticRecord) {
    if(b.ID)
      this.pendingDeletedBallistics.push({IncidentID: this.data.IncidentID, BallisticID: b.ID})

    this.data.Ballistics?.splice(this.data.Ballistics?.indexOf(b),1)
  }

  addPersonRecord() {
    this.data.Persons?.unshift({
      AdditionalNotes: null,
      Address: null,
      Age: null,
      DOB: null,
      Email: null,
      FBI: null,
      FIRSTNAME: null,
      ID: null,
      IncidentID: null,
      LASTNAME: null,
      MI: null,
      Phone: null,
      Rank: null,
      Relationship: null,
      Role: null,
      SBINo: null,
      SBIState: null,
      Sex: null,
      Suffix: null
    })
  }

  deletePersonRecord(p:PersonRecord) {
    if(p.ID)
      this.pendingDeletedPersons.push({IncidentID: this.data.IncidentID, PersonID: p.ID})
    this.data.Persons?.splice(this.data.Persons?.indexOf(p),1)
  }

  submitNJPOPSearch() {
    this.showNJPOPDenyReason = true
    this.incidentService.searchNJPOPIncidents(this.njpopQuery).then((r)=>{

      this.njpopQueryResult = r;
    })
  }

  importNJPOP(njpop: any) {
    this.isNJPOP_Or_Reason_Selected = true

    this.data = <IncidentRecord>{
      ID:this.data.ID,
      IncidentID:this.data.IncidentID,
      Inc_Type: this.data.Inc_Type,
      Inc_RelatedArea: this.data.Inc_RelatedArea,
      LabNumber: this.data.LabNumber,
      Notes: this.data.Notes,
      Inc_State: this.data.Inc_State? this.data.Inc_State: njpop.incidentRecord.Inc_State?.toUpperCase(),
      County: this.data.County? this.data.County: njpop?.incidentRecord?.County?.toUpperCase()?.replace(' COUNTY',''),
      Inc_City: this.data.Inc_City? this.data.Inc_City: njpop.incidentRecord.Inc_City?.toUpperCase(),
      Latitude: this.data.Latitude?this.data.Latitude: njpop.incidentRecord.Latitude,
      Longitude: this.data.Longitude? this.data.Longitude: njpop.incidentRecord.Longitude,
      Inc_Location: this.data.Inc_Location? this.data.Inc_Location: (njpop.incidentRecord.Inc_StreetNumber?njpop.incidentRecord.Inc_StreetNumber:'')  + " " + (njpop.incidentRecord.Inc_StreetName?njpop.incidentRecord.Inc_StreetName:'') + " " + (njpop.incidentRecord.Inc_StreetType?njpop.incidentRecord.Inc_StreetType:''),
      Status: 'POTENTIAL',
      NJPopNo: njpop.incidentRecord.IncidentNum,
      CaseNumber:this.data.CaseNumber? this.data.CaseNumber: njpop.ReportingParty[0].CaseNum?.toUpperCase(),
      SubmissionDate:  this.data.SubmissionDate, //this.data.SubmissionDate? this.data.SubmissionDate: formatDate(njpop?.ReportingParty[0]?.ReportDate,'yyyy-MM-dd','en-US')
      Dept:this.data.Dept? this.data.Dept: njpop.ReportingParty[0].LocalAgencyName?.toUpperCase(),
      OccurrenceDate:this.data.OccurrenceDate? this.data.OccurrenceDate: formatDate(njpop?.incidentRecord?.Inc_DateTime,'yyyy-MM-dd','en-US'),
      OccurrenceTime:this.data.OccurrenceTime? this.data.OccurrenceTime: formatDate(njpop?.incidentRecord?.Inc_DateTime,'HH:mm','en-US'),
      Persons: this.data.Persons && this.data.Persons.length>0 ? this.data.Persons : <PersonRecord[]>[],
      Weapon: this.data.Weapon && this.data.Weapon.length>0 ? this.data.Weapon :<WeaponRecord[]>[],
      Ballistics: this.data.Ballistics && this.data.Ballistics.length>0 ? this.data.Ballistics :<BallisticRecord[]>[],
    };

    this.updateCityAgencyList()

    if (njpop.Persons){
      for (let p of njpop.Persons) {
        this.data.Persons?.push({
          AdditionalNotes: null,
          Address: (p.StreetNumber ? p.StreetNumber : "") + (p.StreetName ? p.StreetName : "") + (p.StreetType ? p.StreetType : ""),
          Age: null,
          DOB: p.DOB,
          Email: null,
          FBI: p.FBI?.toUpperCase(),
          FIRSTNAME: p.FirstName?.toUpperCase(),
          ID: null,
          IncidentID: null,
          LASTNAME: p.LastName?.toUpperCase(),
          MI: p.MiddleName?.toUpperCase(),
          Phone: null,
          Rank: null,
          Relationship: null,
          Role: p.Person_Type?.toUpperCase(),
          SBINo: p.SBI?.toUpperCase(),
          SBIState: (p.SBI) ? "NJ" : null,
          Sex: (p.Gender) ? (p.Gender.length > 0) ? p.Gender[0]?.toUpperCase() : p.Gender?.toUpperCase() : null,
          Suffix: p.Suffix
        })
      }
    }
    this.njpopQueryResult=[];
    this.njpopQueryResult.push(njpop)

    Swal.fire({
      icon: 'success',
      title: 'System Notification',
      text: "Imported NJPOP "+njpop.incidentRecord.IncidentNum+" to Incident Record",
      timerProgressBar:true,
      timer:5000
    })

  }

  async updateCityAgencyList()  {
    if (this.data.Inc_State != null && this.data.County != null) {
      this.dropdownService.getCityForAgencyAndCountyAndState(this.data.County,this.data.Inc_State, this.data.Dept).then(r=>{
        this.cities=r;
        this.addMissingDDLFromInc();
        this.cities = this.cities.sort(function(a, b){
          if(a.City && b.City){
            return a.City.localeCompare(b.City)
          }
          return 0;
        })
        this.SET_FLTR_INC_CITY()
      })
    }
  }

  selectIncidentChange(event: MatOptionSelectionChange) {
    //DEBUG MORE, MIGHT HAVE BUGS. Not Used for Submitting as we take the temp array and join it to a string.
    let p:string = event.source.value;
    let temp:string[] = this.data.Inc_Type? this.data.Inc_Type?.split(','):[]

    if(temp.indexOf(p) == -1){
      temp.push(p)
      this.data.Inc_Type = temp.join(',')
    }else {
      temp.splice(temp.indexOf(p),1)
      this.data.Inc_Type = temp.join(',')
    }
  }

  selectCaseEventChange(event: MatOptionSelectionChange) {

  }

  async updateNJPOPCity() {
    if (this.njpopQuery.county != null) {
      this.dropdownService.getNJPOPCityForCountyAndState(this.njpopQuery.county,'NJ').then(r=>{this.njpopCities=r})
      this.dropdownService.getNJPOPAgencyForCountyAndState(this.njpopQuery.county,'NJ').then(r=>{this.njpopAgencies=r})
      this.SET_FLTR_NJPOP_CITY()
    }
  }

  async updateCountyList() {
    if (this.data.Inc_State != null){
      //this.counties = await this.dropdownService.getCountyForState(this.data.Inc_State)
      this.counties = await this.dropdownService.getCountyForAgencyAndState(this.data.Inc_State, this.data.Dept)

      this.counties = this.counties.sort(function(a, b){
        if(a.County && b.County){
          return a.County.localeCompare(b.County)
        }
        return 0;
      })

      this.SET_FLTR_INC_COUNTY()

    }
  }

  async updateAgencyList() {
    if (this.data.Inc_State != null){
      this.dropdownService.getAgencyForState(this.data.Inc_State).then(r=>{
        this.agencies=r;
        this.addMissingDDLFromInc();
        this.agencies.sort(function(a, b){
          if(a.DeptName && b.DeptName){
            return a.DeptName.localeCompare(b.DeptName)
          }
          return 0;
        })
        this.SET_FLTR_INC_AGENCY();
      })

    }

  }

  isNJPOPMandatory() : boolean{
   for(let i of this.tempIncidents){
      switch(i.toLowerCase()){
        case 'Shooting - Hit'.toLowerCase():
        case 'Shooting - Murder'.toLowerCase():
        case 'Weapon Possession Arrest'.toLowerCase():
          return this.data.Inc_State?.toUpperCase() == 'NJ' || this.data.Inc_State?.toUpperCase() == 'New Jersey'; //Only Return True if the state is New Jersey
      }
    }
    return false
  }

  validateNJPOPStep() : boolean {
    if(this.isNJPOPMandatory())
      return this.isNJPOP_Or_Reason_Selected;
    return true;
  }

  clearNJPOPSearchParam_County() {
    this.njpopQuery.county = null
    this.njpopQuery.city = null
    this.njpopQuery.agency = null
  }
  clearNJPOPSearchParam_City() {
    this.njpopQuery.city = null
  }
  clearNJPOPSearchParam_Agency() {
    this.njpopQuery.agency = null
  }

  clearNJPOPSearchParam_Reason() {
    this.data.NJPOPRejectReason = null
  }

  clearIncidentCounty() {
    this.data.County = null

  }

  clearIncidentCity() {
    this.data.Inc_City = null
  }
  clearIncidentAgency() {
    this.data.Dept = null
    this.data.Inc_City = null
    this.data.County = null
  }

  clearIncidentTime() {
    this.data.OccurrenceTime = '00:00'
  }

  updateIncidentORI($event: MatAutocompleteSelectedEvent) {
    //Update the ORI
    let oriObj = this.agencies.find(o => o.DeptName==$event.option.value)
    if(oriObj){
      if(oriObj.DeptORI)
        this.data.DeptORI = oriObj.DeptORI
    }

    this.updateCountyList()

  }

  updateNJPOPSelectedFlag() {
    this.isNJPOP_Or_Reason_Selected = true;
  }

  async runNewAgencyCityCountyCheck(stepper: MatStepper){
    let proceed = true
    try{
      if(this.agencies && (this.agencies?.filter(o => o.DeptName===this.data.Dept)).length===0) {
        let x = await Swal.fire({
          title: 'Are you sure?',
          text: "This is a new Agency do you want to request it to be added?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        })
        if(!x.isConfirmed)
          proceed = false
      }

      if(this.counties && (this.counties?.filter(o => o.County===this.data.County)).length===0 && proceed){
        let x = await Swal.fire({
          title: 'Are you sure?',
          text: "This is a new County do you want to request it to be added?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        })
        if(!x.isConfirmed)
          proceed = false
      }

      if(this.cities && (this.cities?.filter(o => o.City===this.data.Inc_City)).length===0 && proceed){
        let x = await Swal.fire({
          title: 'Are you sure?',
          text: "This is a new City do you want to request it to be added?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes'
        })
        if(!x.isConfirmed)
          proceed = false
      }
    } catch (e) {

    }

    if(proceed)
      stepper.next();


  }

}
